import { Swiper, SwiperSlide } from 'swiper/react';
import { useState } from 'react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import { ImageVariant } from '../../../../types/catalog';
import { selectImage } from '../../../../util/misc';

export default function SwiperGallery({
    images,
    variants,
}: {
    images: string[];
    variants: ImageVariant[][];
}) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null as any);
    return (
        <div className="product-gallery">
            <div className="product-gallery-thumbs" style={{ overflow: 'hidden' }}>
                <Swiper
                    onSwiper={setThumbsSwiper}
                    freeMode
                    watchSlidesProgress
                    direction="vertical"
                    spaceBetween={30}
                    modules={[FreeMode, Navigation, Thumbs]}
                    slidesPerView={5}
                    className="product-gallery-thumbs__container"
                >
                    {images.map((url, idx) => {
                        const imageUrl = selectImage(variants[idx], 800, 400, url);
                        return (
                            <SwiperSlide key={idx} className="product-gallery-thumbs-item">
                                <div
                                    className="product-gallery-thumbs-item__image"
                                    style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none' }}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            <div className="product-gallery-slider" style={{ overflow: 'hidden' }}>
                <Swiper
                    modules={[FreeMode, Navigation, Thumbs]}
                    direction="vertical"
                    thumbs={{ swiper: thumbsSwiper }}
                    spaceBetween={30}
                    slidesPerView={1}
                    className="product-gallery-slider__container"
                >
                    {images.map((url, idx) => {
                        const imageUrl = selectImage(variants[idx], 800, 400, url);
                        return (
                            <SwiperSlide key={idx} className="product-gallery-slider-item">
                                <div
                                    className="product-gallery-slider-item__image"
                                    style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none' }}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </div>
    );
}
